import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import "./styles.scss";
// import { Editor } from "@tinymce/tinymce-react";
// import { useAppUser } from "../../../../../../../../contexts/user-context/UserContext";
// @ts-ignore
import renderHTML from "react-render-html";
import TextEditor from "../../../../../../../../shared/components/text-editor/TextEditor";
import {RiDeleteBin5Line} from "react-icons/ri";

interface IProps {
  preview?: boolean;
  title: string;
  description: string;
  wkNumber: number;
  onChangeTinyMCE: (text: string) => void;
  onTitleChange: (text: string) => void;
  onRemoveWorkshop: (index: number) => void;
  titleError: string;
  descriptionError: string;
}

interface IState {
  preview?: boolean;
  title: string;
  description: string;
  wkNumber: number;
  onChangeTinyMCE: (text: string) => void;
  onTitleChange: (text: string) => void;
  onRemoveWorkshop: (index: number) => void;
  titleError: string;
  descriptionError: string;
}

const CurriculumComponent = (props: IProps) => {
  const initWorkshop: IState = {
    title: props.title,
    description: props.description,
    wkNumber: props.wkNumber,
    onChangeTinyMCE: props.onChangeTinyMCE,
    onTitleChange: props.onTitleChange,
    onRemoveWorkshop: props.onRemoveWorkshop,
    titleError: props.titleError,
    descriptionError: props.descriptionError,
  };

  const [workshop, setWorkshop] = useState(initWorkshop);
  // const appUser = useAppUser();

  const heddleTextEditor = (content: any, editor: any) => {
    props.onChangeTinyMCE(content);
    setWorkshop({
      ...workshop,
      descriptionError: "",
    });
  };

  useEffect(() => {
    setWorkshop((ps) => ({ ...ps, description: props.description }));
  }, [props.description]);

  useEffect(() => {
    setWorkshop((prevState) => {
      return Object.assign(
        {},
        {
          titleError: props.titleError,
          descriptionError: props.descriptionError,
          title: prevState.title,
          description: prevState.description,
          wkNumber: prevState.wkNumber,
          onChangeTinyMCE: prevState.onChangeTinyMCE,
          onTitleChange: prevState.onTitleChange,
          onRemoveWorkshop: prevState.onRemoveWorkshop
        }
      );
    });
  }, [props.descriptionError, props.titleError]);

    return (
    <>
      <Row>
        <Col xs={4}>
          <div
            style={{
              backgroundColor: "#505050",
              color: "white",
              letterSpacing: "4px",
              fontSize: "small",
              fontWeight: "normal",
              maxWidth: "350px",
              paddingTop: "12px",
              paddingBottom: "10px",
              marginBottom: "20px",
            }}
            className="pl-3 mt-3"
          >
            {"WORKSHOP " + workshop.wkNumber}
          </div>
        </Col>
        <Col xs={3}>
          {!props.preview && workshop.wkNumber > 1 && (
            <div
              className="workshop-remove-button"
              onClick={() => {
                props.onRemoveWorkshop(workshop.wkNumber - 1);
              }}
            >
              <RiDeleteBin5Line size={20} /> Remove
            </div>
          )}
        </Col>
      </Row>
      <Row>
        <Col
          xs={props.preview ? 12 : 8}
          className="text-left font-weight-bold"
          style={{ color: "rgb(7, 66, 94)", width: "100%" }}
        >
          {props.preview ? (
            <>
              <p className="workshop-title-preview">{workshop.title}</p>
            </>
          ) : (
            <>
              <label style={{ color: "#505050", fontWeight: "bold" }}>
                Workshop Title{" "}
                <span className="ml-1" style={{ color: "red" }}>
                  *
                </span>
              </label>
              <input
                className={
                  workshop.titleError.length < 1
                    ? "app-input"
                    : "app-input invalid"
                }
                placeholder="Workshop Title"
                value={workshop.title}
                onChange={(e) => {
                  props.onTitleChange(e.target.value);
                  setWorkshop({
                    ...workshop,
                    title: e.target.value,
                    titleError: "",
                  });
                }}
              />
              <label className="error-message">{workshop.titleError}</label>
            </>
          )}
        </Col>
      </Row>
      <Row>
        <Col
          xs={12}
          className="text-left font-weight-bold"
          style={{ color: "rgb(7, 66, 94)", width: "100%" }}
        >
          {props.preview ? (
            <>{renderHTML(workshop.description || "")}</>
          ) : (
            <>
              <TextEditor
                initialValue={props.description}
                onEditorChange={heddleTextEditor}
              />
              <label className="error-message">
                {workshop.descriptionError}
              </label>
            </>
          )}
        </Col>
      </Row>
    </>
  );
};

export default CurriculumComponent;
